<template>
    <div class="boolean-toggle-field">
        <label class="boolean-toggle-field__label poppinsMedium">{{ label }}</label>
        <div class="boolean-toggle">
            <button
                type="button"
                :class="['boolean-toggle__btn', { 'boolean-toggle__btn--active': !value }]"
                @click="updateValue(false)"
            >
                {{ falseLabel }}
            </button>
            <button
                type="button"
                :class="['boolean-toggle__btn', { 'boolean-toggle__btn--active': value }]"
                @click="updateValue(true)"
            >
                {{ trueLabel }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BaseBooleanToggle',
    props: {
        value: { type: Boolean, default: false },
        label: { type: String, default: '' },
        trueLabel: { type: String, default: 'Oui' },
        falseLabel: { type: String, default: 'Non' },
    },
    methods: {
        updateValue(nextValue) {
            if (this.value !== nextValue) {
                this.$emit('input', nextValue)
            }
        },
    },
}
</script>

<style scoped>
.boolean-toggle-field {
    display: flex;
    flex-direction: column;
}

.boolean-toggle-field__label {
    font-size: 10px;
    margin-bottom: 4px;
    color: rgba(0, 0, 0, 0.7);
}

.dark .boolean-toggle-field__label {
    color: rgba(255, 255, 255, 0.7);
}

.boolean-toggle {
    display: inline-flex;
    border-radius: 30px;
    background-color: rgba(0, 0, 0, 0.06);
    height: 30px;
    padding: 3px;
    gap: 0;
}

.dark .boolean-toggle {
    background-color: rgba(255, 255, 255, 0.08);
}

.boolean-toggle__btn {
    border: none;
    outline: none;
    cursor: pointer;
    background: transparent;
    padding: 0 14px;
    font-size: 12px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.55);
    transition: all 0.2s ease;
    font-family: 'Poppins', sans-serif;
    border-radius: 30px;
    line-height: 24px;
}

.dark .boolean-toggle__btn {
    color: rgba(255, 255, 255, 0.55);
}

.boolean-toggle__btn--active {
    background-color: #545595;
    color: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}
</style>
